//* The following contains methods to format the labs text
const FormatAPI = {
  data() {
    return {};
  },
  methods: {
    //* The following function is used to render superscript - you can import it into any component or view and reuse it
    renderFormattedExpression(text) {
      // format the text to return with superscript if the string contains ^ in it
      // check if there is text
      if (!text) return;
      if (text.includes("^")) {
        // split into two parts, the first part is the text before the ^, the second part is the text after the ^
        const splitText = text.split("^");
        // only put in the superscript the first character after the ^
        return `${splitText[0]}<sup>${splitText[1].charAt(
          0
        )}</sup>${splitText[1].slice(1)}`;
      }
      return text;
    },
    //* render formatted in superscript for everything between "^(" and ")"
    renderFormatSuperscript(text) {
      if (!text) return;
      if (text.includes("^")) {
        // split into parts and only place everything after the ^ but before the ) in superscript
        const splitTextOne = text.split("^");
        const splitTextTwo = splitTextOne[1].split(")");
        // if there is a ) in the text, return the text with superscript
        if (splitTextTwo.length > 1) {
          return `${splitTextOne[0]}<sup>${splitTextTwo[0]}</sup>${splitTextTwo[1]})`;
        } else {
          return `${splitTextOne[0]}<sup>${splitTextTwo[0]}</sup>`;
        }
      }
      return text;
    },
    renderSuperscript(text) {
      // Use a regular expression to find all occurrences of text between "^(" and ")"
      const regex = /\^\((.*?)\)/g;

      // Replace each occurrence with the same text wrapped in <sup> tags
      const result = text.replace(
        regex,
        (match, content) => `<sup>${content}</sup>`
      );

      return result;
    },
    //* render formatted in subscript for everything between "_(" and ")"
    renderFormatSubscript(text) {
      if (!text) return;
      // Use regular expression to match text between "_(" and ")"
      const stringWithSubscript = text.replace(/_\((.*?)\)/g, (_, match) => {
        // Wrap the matched text in <sub> tags
        return `<sub>${match}</sub>`;
      });

      return stringWithSubscript;
    },
    //* figure out if the text is a superscript or subscript
    renderFormatSuperscriptOrSubscript(text) {
      if (!text) return;
      if (text.includes("^(") && text.includes("_(")) {
        let subscriptedText = this.renderFormatSubscript(text);
        return this.renderSuperscript(subscriptedText);
      } else if (text.includes("^(")) {
        return this.renderSuperscript(text);
      } else if (text.includes("_(")) {
        return this.renderFormatSubscript(text);
      }
      return text;
    }
  }
};

export default FormatAPI;
